<template lang="pug" src="./template/PopularDealCard.pug"></template>
<style lang="stylus" src="./styles/PopularDealCard.styl" scoped></style>

<script>
export default {
    props: ['deal'],



};
</script>
